/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Group_TitleInputs */

const en_directory_taxonomy_index_group_title = /** @type {(inputs: Directory_Taxonomy_Index_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a category`)
};

const zh_directory_taxonomy_index_group_title = /** @type {(inputs: Directory_Taxonomy_Index_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从分类开始`)
};

/**
* | output |
* | --- |
* | "Start with a category" |
*
* @param {Directory_Taxonomy_Index_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_group_title = /** @type {((inputs?: Directory_Taxonomy_Index_Group_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Group_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_group_title(inputs)
	return zh_directory_taxonomy_index_group_title(inputs)
});
export { directory_taxonomy_index_group_title as "directory.taxonomy_index.group.title" }